<dx-number-box
  stylingMode="filled"
  valueChangeEvent="keyup input change"
  [label]="label"
  [(value)]="value"
  [readOnly]="!isEditing"
  [elementAttr]="{ class: 'form-editor' }"
  [inputAttr]="{ class: 'form-editor-input' }"
  (onValueChanged)="valueChanged($event)"
>
  <dx-validator [validationRules]="validationRules()"></dx-validator>
  <dxi-button
    *ngIf="icon"
    name="icon"
    location="before"
    [options]="{ icon: icon, elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
  ></dxi-button>
</dx-number-box>
